<template>
  <div class="ace-editor-wrapper">
    <div :class="{'has-placeholder': placeholder}"
         :id="'ace-editor-' + _uid"
         :style="{height: autoHeight ? 'auto' : height, width: '100%', fontSize: fontSize + 'px'}"
         class="ace-editor"></div>
    <pre v-if="placeholder && showPlaceholder"
         :style="{lineHeight: placeholderHeight, fontSize: fontSize + 'px', left: placeholderLeft}"
         class="editor-placeholder">{{ placeholder }}</pre>
  </div>
</template>

<script>
let AceEditor

if (process.browser || process.type === 'renderer') {
  AceEditor = require('ace-builds')
  // require('ace-builds/src-min-noconflict/theme-idle_fingers')
  require('./theme/ayu-light.js')
  require('ace-builds/src-min-noconflict/mode-python')
  require('ace-builds/src-min-noconflict/mode-c_cpp')
  require('ace-builds/src-min-noconflict/mode-text')
  require('ace-builds/src-min-noconflict/snippets/c_cpp')
  require('ace-builds/src-min-noconflict/snippets/text')
  require('ace-builds/src-min-noconflict/ext-language_tools')
  require('ace-builds/src-min-noconflict/ext-whitespace')
  require('./snippets/python')
}

export default {
  props: {
    value: String,
    height: {
      default: '160px'
    },
    minLines: { type: Number, default: 0 },
    readOnly: { type: Boolean, default: false },
    hideCursor: { type: Boolean, default: false },
    lang: { type: String, default: 'python' },
    theme: { type: String, default: 'ayu-light' },
    fontSize: { type: Number, default: 16 },
    autoHeight: { type: Boolean, default: false },
    run: { type: Function },
    options: { type: Object },
    placeholder: { type: String },
    showPlaceholder: { type: Boolean }
  },
  data () {
    return {
      oldHash: '',
      contentBackup: '',
      loaded: false,
      skipNextChangeEvent: false,
      placeholderLeft: '48px',
      placeholderHeight: '23px'
    }
  },
  computed: {
    lines () {
      if (this.value) {
        return this.value.split('\n').length
      }
      return 0
    }
  },
  mounted () {
    const editor = this.editor = AceEditor.edit('ace-editor-' + this._uid)
    if (this.hideCursor) {
      editor.renderer.$cursorLayer.element.style.display = 'none'
    }
    editor.$blockScrolling = Infinity
    editor.getSession().setMode('ace/mode/' + this.lang)
    editor.setValue(this.value || '', 1)
    editor.setOptions(this.options || {
      enableSnippets: true,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      theme: 'ace/theme/' + this.theme,

      // renderer options
      showInvisibles: true,
      showPrintMargin: true,
      useSoftTabs: true,
      wrap: false,
      indentedSoftWrap: false,
      wrapBehavioursEnabled: false,
      readOnly: this.readOnly
    })

    if (this.autoHeight) {
      editor.setOptions({
        maxLines: Infinity
      })
    }
    if (this.minLines) {
      editor.setOptions({
        minLines: this.minLines
      })
    }

    this.contentBackup = this.value
    editor.on('change', () => {
      const content = editor.getValue()
      this.$emit('input', content)
      this.contentBackup = content
    })

    if (this.run) {
      editor.commands.addCommand({
        name: 'runCode',
        bindKey: { win: 'Ctrl-Enter', mac: 'Command-Enter' },
        exec: this.run
      })
    }
  },
  watch: {
    value (value) {
      if (this.placeholder) {
        const scroller = document.getElementsByClassName('ace_scroller')[0]
        this.placeholderLeft = parseInt(scroller.style.left.replace('px', '')) + 4 + 'px'
        const line = document.getElementsByClassName('ace_line_group')[0]
        if (line) {
          this.placeholderHeight = line.style.height
        }
      }
      if (this.hash && this.hash !== this.oldHash) {
        this.editor.setValue(value || '', 1)
        this.oldHash = this.hash
        this.contentBackup = value
        return
      }
      if (this.contentBackup !== value) {
        this.editor.setValue(value || '', 1)
        this.contentBackup = value
      }
    },
    theme (theme) {
      this.editor && this.editor.setOption('theme', 'ace/theme/' + theme)
    }
  },
  beforeDestroy () {
    if (this.editor) {
      this.editor.destroy()
      this.editor.container.remove()
    }
  }
}
</script>
<style>
.template-editor .ace_gutter-cell,
.template-editor .ace_active-line,
.template-editor .ace_cursor {
  opacity: 0;
}

.template-editor .ace_content {
  background: white;
}

.ace-chrome .ace_gutter {
  background: #F0F0F0 !important;
}

.ace_scroller {
  -webkit-overflow-scrolling: touch;
}

div span span.ace_mobile-button {
  border-left: 1px solid;
}

.ace_mobile-button:first-child {
  border-left: none;
}

/*AceEditor 内部创建*/
.ace_editor {
  font-family: Monaco, Menlo, "Ubuntu Mono", Consolas, source-code-pro, monospace;;
}

.ace-editor-wrapper {
  position: relative;
  background: white;
  overflow: hidden;
}

.ace-editor-wrapper .ace-ayu-light {
  background: none;
}

.ace-editor {
  position: relative;
  z-index: 1;
}

.has-placeholder .ace_active-line {
  opacity: 0 !important;
}

.has-placeholder .ace_invisible {
  opacity: 0 !important;
}

.editor-placeholder {
  padding: 0;
  position: absolute;
  left: 24px;
  top: 0;
  z-index: 0;
  font-size: 20px;
  line-height: 23px;
  color: #CCCCCC;
  background: none;
  font-family: Monaco, Menlo, "Ubuntu Mono", Consolas, source-code-pro, monospace;;
}
</style>
